export const adminPermissions = {
  canAccounting: "حسابداری",
  canAdmins: "مدیریت ادمین ها",
  canProducts: "مدیریت محصولات",
  canTables: "مدیریت میزها",
  canSetting: "تنظیمات",
  canProfit: "بررسی سود",
};
export const adminLogUrls = {
  "/user": "کاربران",
  "/setting": "تنظیمات",
  "/transaction": "تراکنشات",
  "/product": "محصولات",
  "/table": "میزها",
  "/order": "سفارشات",
  "/cue": "تنظیمات چوب",
  "/cost": "هزینه ها",
  "/log": "رویدادنگاری",
  "/login": "ورود",
};
export const userRoleItems = ["ADMIN", "CUSTOMER"];
export const logMethodItems = ["GET", "POST", "DELETE", "PUT", "PATCH"];
export const transactionTypeItems = ["DEPOSIT", "WITHDRAWAL"];
export const genderTypeItems = ["MALE", "FEMALE"];
export const orderStatusItems = ["OPENED", "COMPLETED"];
export const costTypeItems = ["VARIABLE", "CONSTANT"];
export const uploadTypeItems = [
  "OTHERS",
  "AVATAR",
  "TICKETS",
  "DOCUMENTS",
  "PASS",
];
export const sortItems = ["asc", "desc"];
export const lastDaysItems = [7, 15, 30, 90, 180, 365];

//* Start Convert To Text
export const convertLogUrlToText = (type) => {
  if (!type) return;

  const urls = Object.keys(adminLogUrls);
  let result = type;
  for (const url of urls) {
    if (type.includes(url)) result = adminLogUrls[url];
  }
  return result;
};
export const convertLogMethodToText = (type) => {
  let result = "";
  switch (type) {
    case logMethodItems[0]:
      result = "واکشی";
      break;
    case logMethodItems[1]:
      result = "ایجاد";
      break;
    case logMethodItems[2]:
      result = "حذف";
      break;
    case logMethodItems[3]:
      result = "ویرایش";
      break;
    case logMethodItems[4]:
      result = "ویرایش جزئی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertSortToText = (type) => {
  let result = "";
  switch (type) {
    case sortItems[0]:
      result = "صعودی";
      break;
    case sortItems[1]:
      result = "نزولی";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertRoleToTitle = (type) => {
  let result = "";
  switch (type) {
    case userRoleItems[0]:
      result = "ادمین ها";
      break;
    case userRoleItems[1]:
      result = "مشتری ها";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertTransactionTypeToText = (type) => {
  let result = "";
  switch (type) {
    case transactionTypeItems[0]:
      result = "افزایش";
      break;
    case transactionTypeItems[1]:
      result = "کاهش";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertGenderTypeToText = (type) => {
  let result = "";
  switch (type) {
    case genderTypeItems[0]:
      result = "مرد";
      break;
    case genderTypeItems[1]:
      result = "زن";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertOrderStatusToText = (type) => {
  let result = "";
  switch (type) {
    case orderStatusItems[0]:
      result = "باز";
      break;
    case orderStatusItems[1]:
      result = "تکمیل شده";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertCostTypeToText = (type) => {
  let result = "";
  switch (type) {
    case costTypeItems[0]:
      result = "متغیر";
      break;
    case costTypeItems[1]:
      result = "ثابت";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Text

//* Start Convert To Color
export const convertLogMethodToColor = (type) => {
  let result = "";
  switch (type) {
    case logMethodItems[0]:
      result = "primary";
      break;
    case logMethodItems[1]:
      result = "success";
      break;
    case logMethodItems[2]:
      result = "danger";
      break;
    case logMethodItems[3]:
      result = "warning";
      break;
    case logMethodItems[4]:
      result = "info";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertTransactionTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case transactionTypeItems[0]:
      result = "success";
      break;
    case transactionTypeItems[1]:
      result = "danger";
      break;
    case transactionTypeItems[2]:
      result = "primary";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertOrderStatusToColor = (type) => {
  let result = "";
  switch (type) {
    case orderStatusItems[0]:
      result = "warning";
      break;
    case orderStatusItems[1]:
      result = "success";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const convertCostTypeToColor = (type) => {
  let result = "";
  switch (type) {
    case costTypeItems[0]:
      result = "primary";
      break;
    case costTypeItems[1]:
      result = "secondary";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Convert To Color
